import { API_URL } from "../../config/connect";

/**
 * Post user location to the backend
 * Supports both old format (with country, province, locality, etc.) and new format (with country_id, region_id, district_id)
 * @param {Object} locationData - Location data object
 * @param {number} locationData.country_id - Country ID from Location API (optional)
 * @param {number} locationData.region_id - Region ID from Location API (optional)
 * @param {number} locationData.district_id - District ID from Location API (optional)
 * @param {string} locationData.country - Country name (for backward compatibility)
 * @param {string} locationData.province - Province/Region name (for backward compatibility)
 * @param {string} locationData.locality - Locality name (for backward compatibility)
 * @param {string} locationData.area - Area name (for backward compatibility)
 * @param {string} locationData.street - Street name
 * @param {string} locationData.house - House number
 * @param {number} locationData.latitude - Latitude coordinate
 * @param {number} locationData.longitude - Longitude coordinate
 * @returns {Promise<Object>} Response from the server
 */
export async function postUserLocation(locationData) {
  const endpoint = `${API_URL}/api/v1/user/location`;

  try {
    const accessToken = localStorage.getItem("access_token");

    if (!accessToken) {
      throw new Error("Access token is missing");
    }

    // Prepare location data with both old and new format support
    const requestData = {
      ...locationData,
      // Include new Location API IDs if provided
      ...(locationData.country_id && { country_id: locationData.country_id }),
      ...(locationData.region_id && { region_id: locationData.region_id }),
      ...(locationData.district_id && { district_id: locationData.district_id }),
    };

    const response = await fetch(endpoint, {
      method: 'POST',
      headers: {
        'Authorization': `Bearer ${accessToken}`,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(requestData)
    });

    if (!response.ok) {
      throw new Error(`Error: ${response.statusText}`);
    }

    const result = await response.json();
    return result;
  } catch (error) {
    console.error('Failed to post location:', error);
    throw error;
  }
}